/* global I18n */
import React, { useContext, useEffect, useRef } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  filesI18nOptions,
  PREVIEW,
  PREVIEW_COUNT,
  PREVIEWS,
  SEARCH_PREVIEW_COUNT,
} from '../../components/products/constants'
import { UIContext } from '../../contexts/UIContext'

const hidden = { display: 'none' }

const message = (translation, setCurrentTab) => {
  return (
    <>
      <a onClick={() => setCurrentTab(PREVIEW)} className="field-link">
        {`${I18n.t('images', filesI18nOptions)}: `}
      </a>
      <span className="error-messages">{I18n.t(translation, filesI18nOptions)}</span>
    </>
  )
}

export default function PreviewValidations({
  searchPreviewRequired,
  previewCount,
  searchPreviewCount,
}) {
  const { setCurrentTab } = useContext(UIContext)
  const { register, setValue } = useFormContext()

  const initialized = useRef(false)

  // Update value of inputs when previews change
  useEffect(() => {
    setValue(`${PREVIEWS}.${PREVIEW_COUNT}`, previewCount, { shouldValidate: initialized.current })
    setValue(`${PREVIEWS}.${SEARCH_PREVIEW_COUNT}`, searchPreviewCount, { shouldValidate: initialized.current })
    initialized.current = true
  }, [previewCount, searchPreviewCount, searchPreviewRequired])

  return (
    <>
      <input
        style={hidden}
        value={previewCount}
        {...register(
          `${PREVIEWS}.${PREVIEW_COUNT}`, {
            required: true,
            min: {
              value: 5,
              message: message('not_enough_previews', setCurrentTab),
            },
          }
        )
        }
      />
      <input
        style={hidden}
        value={searchPreviewCount}
        {...register(`${PREVIEWS}.${SEARCH_PREVIEW_COUNT}`, {
          required: true,
          min: {
            value: 1,
            message: message('first_preview_validation_fail', setCurrentTab),
          },
        })}
      />
    </>
  )
}
